/**
 * CelebrationListener — listens for celebration events and fires confetti
 */
import { useEffect } from 'react';
import confetti from 'canvas-confetti';

const fireConfetti = (intensity) => {
  switch (intensity) {
    case 'small':
      confetti({ particleCount: 50, spread: 60, origin: { y: 0.7 }, zIndex: 9999 });
      break;
    case 'medium':
      confetti({ particleCount: 80, angle: 60, spread: 55, origin: { x: 0, y: 0.65 }, zIndex: 9999 });
      confetti({ particleCount: 80, angle: 120, spread: 55, origin: { x: 1, y: 0.65 }, zIndex: 9999 });
      break;
    case 'large':
      confetti({ particleCount: 100, spread: 70, origin: { y: 0.6 }, zIndex: 9999 });
      setTimeout(() => confetti({ particleCount: 80, angle: 60, spread: 55, origin: { x: 0, y: 0.65 }, zIndex: 9999 }), 200);
      setTimeout(() => confetti({ particleCount: 80, angle: 120, spread: 55, origin: { x: 1, y: 0.65 }, zIndex: 9999 }), 400);
      break;
    default:
      break;
  }
};

const CelebrationListener = () => {
  useEffect(() => {
    const handler = (e) => {
      if (localStorage.getItem('thrive-celebrations') === 'off') return;

      const { intensity, modal: isModal } = e.detail;

      if (intensity && intensity !== 'sparkle') {
        fireConfetti(intensity);
      }

      // Extra confetti bursts for big moments
      if (isModal) {
        setTimeout(() => fireConfetti('large'), 600);
      }
    };

    window.addEventListener('celebration', handler);
    return () => window.removeEventListener('celebration', handler);
  }, []);

  return null;
};

export default CelebrationListener;
